module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/cxHaMy/media/FC-9781035863594.jpg?1736791168157",
      "alt": "This image is the cover for the book Animal World Adventure"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Animal World Adventure\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Hold on tight! An amazing adventure awaits. It all begins with two best friends, Hazel and Violet. For Violet’s birthday, she wishes to visit the forest, somewhere she hasn’t been in ages. Little do they know, an entirely new world is waiting to be discovered. Warned by the animals that an evil force is trying to stop them, they suddenly find themselves teleported to a strange world under a black sky. Determined to save it, they embark on a daring quest. But the big question remains: Can they succeed?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sabrine Arafa\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("When Sabrine was just six years old, she would buy books and write the shortest stories imaginable. She always dreamed of becoming a successful writer. She would often bring her incomplete stories to her dad and ask, ‘can you sell it?’ and he would say ‘yes, I will!’")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0